export const RES_LOAD = 'RES_LOAD';
export const RES_UPDATE = 'RES_UPDATE';
